export default __webpack_public_path__ + "static/media/zoompic.52706610.less";